<template>
  <div class="registration">
    <registration-header :data="data" :current="current" />

    <div class="registration_attachment">
      <div
        v-for="v in data.attachments"
        style="margin-bottom: 30px"
        :key="v.id"
      >
        <section-header
          :name="v.name"
          :description="v.description"
          :requiredFlag="v.requiredFlag"
        />
        <Upload
          class="text-left"
          :on-success="fileSuccess"
          :default-file-list="
            $_.filter(form.attachments, (val) => {
              return val.dictItemId === v.dictItemId;
            })
          "
          :on-error="fileError"
          :on-remove="del"
          accept="image/jpeg, image/png, image/jpeg, .dotx, application/vnd.openxmlformats-officedocument.wordprocessingml.template, .docx, application/vnd.openxmlformats-officedocument.wordprocessingml.document.pdf, application/pdf, .wps, application/vnd.ms-works, application/vnd.ms-excel, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          :format="['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx', 'xls', 'xlsx']"
          :action="`${mainApiEndpoint}/rest/api/v1/registration/form/attachment/${$route.params.teamId}/${$route.params.formId}/${v.dictItemId}`"
          :max-size="20 * 1024"
          :on-exceeded-size="onExceededSize"
          :on-format-error="onExceededSize"
        >
          <Button icon="ios-cloud-upload-outline">
            {{ $t('apply.add_attachments') }}
          </Button>
        </Upload>
        <p class="gary-text text-left">
          {{ $t('global.img_file_text') }}
        </p>
      </div>
    </div>

    <div class="registration_footer">
      <Button type="primary" @click="$router.back()" ghost>
        {{ $t('global.text18') }}
      </Button>
      <Button type="primary" @click="next">
        {{ $t('global.text17') }}
      </Button>
    </div>
  </div>
</template>
<script>
import RegistrationHeader from './components/RegistrationHeader.vue';
import SectionHeader from './components/SectionHeader.vue';
import app_config from '@/commons/app_config';
import { mapState, mapMutations } from 'vuex';
import axios from 'axios';
export default {
  components: {
    RegistrationHeader,
    SectionHeader
  },
  data() {
    return {
      sb_loading: false,
      mainApiEndpoint: app_config.mainApiEndpoint,
      success_files: []
    };
  },
  computed: {
    ...mapState({
      data: (state) => state.r_form,
      form: (state) => state.form
    }),
    current() {
      const { guide } = this.data;
      const isGuide = guide && guide.enableFlag;
      if (isGuide) return 2;
      return 1;
    }
  },
  created() {
    if (
      !sessionStorage.getItem('codeVerification') &&
      !this.$route.query.view
    ) {
      alert(this.$t('global.codeExpire'));
      this.$router.replace(
        `/registration/welcome/${this.$route.params.teamId}/${this.$route.params.registrationTemplateId}`
      );
    }

    if (this.form.attachments) {
      _.forEach(this.form.attachments, (e) => {
        this.success_files.push({
          key: e.key,
          dictItemId: e.dictItemId
        });
      });
    } else {
      this.set_form1({
        ...this.form,
        attachments: []
      });
    }
  },
  methods: {
    ...mapMutations({
      set_form1: 'set_form1'
    }),
    onExceededSize() {
      this.$Message.error(this.$t('global.img_file_text'));
    },
    fileSuccess(response) {
      try {
        this.form.attachments.push(response);
        this.set_form1(this.form);
        this.success_files.push({
          key: response.key,
          dictItemId: response.dictItemId
        });
        this.$Message.success(this.$t('global.import_success_msg'));
      } catch (e) {
        this.$Modal.error({
          title: this.$t('global.warn'),
          content: this.$t('global.fileError')
        });
      }
    },
    next() {
      if (this.$route.query.view) {
        this.$router.push({ path: '/registration/success' });
      } else {
        let validate = [];
        _.forEach(this.data.attachments, (v) => {
          if (v.requiredFlag) {
            if (
              !_.find(this.success_files, (e) => e.dictItemId === v.dictItemId)
            ) {
              validate.push(v.name);
            }
          }
        });
        if (validate.length > 0) {
          this.$Message.error(
            `${validate.join(',')}${this.$t('apply.not_empty')}`
          );
        } else {
          this.$router.push({ path: '/registration/success' });
        }
      }
    },
    fileError(response, res) {
      this.$Message.error(res.message);
    },
    async del(v) {
      let dictItemId = v.response ? v.response.dictItemId : v.dictItemId;
      let key = v.response ? v.response.key : v.key;
      try {
        await axios({
          method: 'DELETE',
          url: `${this.mainApiEndpoint}/rest/api/v1/registration/form/attachment/${this.$route.params.teamId}/${this.$route.params.formId}/${dictItemId}?key=${key}`,
          headers: {
            'X-TENANT-ID': this.$route.params.teamId
          }
        });
        _.remove(this.success_files, (i) => {
          return i.key === key;
        });
        _.remove(this.form.attachments, (val) => {
          return val.key === key;
        });
        this.set_form1(this.form);
        this.$Message.success(this.$t('apply.deleted'));
      } catch (e) {
        this.$Message.error({
          content: e.response.data.message,
          duration: 8
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.registration {
  overflow-y: scroll;
  height: 100vh;

  &_attachment {
    max-width: 1200px;
    margin: 84px auto;
    background-color: #fff;
    z-index: 100;
    padding: 32px;
    box-shadow: 0px 2px 20px 0px rgba(11, 4, 84, 0.08);
  }

  &_footer {
    background-color: #fff;
    box-shadow: 0px 2px 20px 0px rgba(11, 4, 84, 0.08);
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 56px;
    bottom: 0;
    width: 100%;
    gap: 12px;
    z-index: 100;
  }
}

@media only screen and (max-width: 768px) {
  .registration_attachment {
    width: 100%;
    padding: 15px 15px 100px 15px;
  }
}
</style>
